import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import MeetTheAndersons from "@/components/site/MeetTheAndersons";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import WhyB3 from "@/components/site/WhyB3";
import Reviews from "@/components/site/Reviews";
import ServiceArea from "@/components/site/ServiceArea";
import CTABand from "@/components/site/CTABand";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import InvoicePay from "@/pages/InvoicePay";
import PaymentSuccess from "@/pages/PaymentSuccess";
import CityPage from "@/pages/CityPage";
import ServicePage from "@/pages/ServicePage";

function MarketingSite() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true, anchors: { offset: -80 } }}>
      <div className="App relative bg-ink text-white font-body antialiased overflow-x-hidden">
        <div className="grain" aria-hidden="true" />
        <Header />
        <main>
          <Hero />
          <About />
          <MeetTheAndersons />
          <Services />
          <Gallery />
          <WhyB3 />
          <Reviews />
          <ServiceArea />
          <CTABand />
          <Contact />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MarketingSite />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/invoice/:token" element={<InvoicePay />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/contractor/:slug" element={<CityPage />} />
        <Route path="/services/:slug" element={<ServicePage />} />
      </Routes>
      <Toaster position="top-center" theme="dark" richColors />
    </BrowserRouter>
  );
}

export default App;
